export default {
	stripeButton: {
		marginTop: "23px",
		height: "50px",

		"@media (max-width:600px)": {
			marginTop: "0px"
		}
	}
}
